import React from 'react';
import { useModalRenewedPermitData } from '../../../../../stores/renewedPermitModal.store';
import { formatCurrencyNis } from '../../../../../helpers/formating-currency';
import renewedPermitModalLang from '../../../../../data/lang/homePage/renewedPermitModal.lang';
import { useTags } from '../../../../../hooks/useTags';


const DisplayConfirmation = () => {

    const renewedPermitData = useModalRenewedPermitData();
    const { renewedPermitStep, renewedPermitConfirmation } = renewedPermitData;
    const { asmachta, hasReceipt, paymentAmount } = renewedPermitConfirmation.paymentProcessResult;

    const generateTag = useTags();

    const confirmationLine1Tag = generateTag(renewedPermitModalLang, 'renewed-permit-confirmation.confirmation-line-1');
    const confirmationLine2Tag = generateTag(renewedPermitModalLang, 'renewed-permit-confirmation.confirmation-line-2');
    const confirmationLine3Tag = generateTag(renewedPermitModalLang, 'renewed-permit-confirmation.confirmation-line-3');
    const moneyFormetted = formatCurrencyNis(paymentAmount);

    if (renewedPermitStep !== 'confirmation') {
        return null;
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        }}>
            <div className='text-center fs-3 mt-2 mb-2'>{confirmationLine1Tag}</div>

            {hasReceipt && (
                <div className='fs-4'>
                    <div>
                        {confirmationLine2Tag} <span className='fst-italic'>{moneyFormetted}</span>
                    </div>
                    <div>
                        {confirmationLine3Tag} <span className='fst-italic'>{asmachta}</span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DisplayConfirmation;